module.exports = __webpack_public_path__ + "img/redEnvelopedRainTitleImage.e37495ad.png";